import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

import {DS_API_BASE_PATH} from '../consts'
import {OptimizerFeature} from '../types'

interface PlantConfigData {
  available_features: OptimizerFeature[]
}

export const PlantConfigQueryKey = 'plantConfig'

const usePlantConfigQuery = () => {
  // Use UpmPlantContext to get plantCode - works in both HCEM and Suite
  const {plantId: plantCode} = useUpmPlantContext()

  return useQuery<PlantConfigData>({
    queryKey: [PlantConfigQueryKey, plantCode],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<PlantConfigData>(
        `${DS_API_BASE_PATH}/v2/config/${plantCode}`,
        {signal}
      )
      return response.data
    },
    enabled: Boolean(plantCode)
  })
}

/**
 * @deprecated Remove after optimizer features are exported to config cat
 */
export const usePlannerFeature = (feature: OptimizerFeature): boolean => {
  const {data: plantConfig} = usePlantConfigQuery()
  const availableFeatures = plantConfig?.available_features || []

  return availableFeatures.includes(feature)
}
